<template>
  <div class="login-wrap">
    <div class="login-title">医诺数据中心平台</div>
    <Form ref="formInline" :model="formInline" :rules="ruleInline">
      <FormItem prop="loginName">
        <Input type="text" v-model="formInline.loginName" placeholder="账号">
          <Icon type="ios-person-outline" slot="prepend"></Icon>
        </Input>
      </FormItem>
      <FormItem prop="password">
        <Input type="password" v-model="formInline.password" placeholder="密码">
          <Icon type="ios-lock-outline" slot="prepend"></Icon>
        </Input>
      </FormItem>
      <FormItem>
        <Button type="primary" long @click="handleSubmit('formInline')">登录</Button>
      </FormItem>
    </Form>
  </div>
</template>
<script>
import { login , userMsg } from "./../http/commom";
import axios from './../http'
export default {
  data() {
    return {
      menu:[],
      flag: false,
      formInline: {
        loginName: "",
        password: ""
      },
      ruleInline: {
        loginName: [
          { required: true, message: "用户名不允许为空", trigger: "blur" }
        ],
        password: [
          { required: true, message: "密码不允许为空", trigger: "blur" },
          {
            type: "string",
            min: 6,
            message: "密码长度不允许低于6位",
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    ceshi() {
      this.flag = true;
    },
    close() {
      this.flag = false;
    },
    confirm() {
      console.log(this.formInline);
      this.flag = false;
    },
    //登录接口
    handleSubmit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
            login({
               loginType: 2,
              ...this.formInline
            }).then(res=>{
              localStorage.setItem('data-center-token',res.token);
              this.$tips(this, "登录成功", "success");
                if(res.type==0){
                     this.menu = [
                        {
                          icon: "ios-body",
                          name: "业务管理",
                          id: 1,
                          children: [
                            {
                              id: 2,
                              name: "客户管理",
                              path: "/Customer"
                            },
                          ]
                        }
                    ];
                }else if(res.type==1){
                    this.menu = [
                      {
                        icon: "ios-body",
                        name: "业务管理",
                        id: 1,
                        children: [
                          {
                            id: 2,
                            name: "实验室管理",
                            path: "/laboratory"
                          }
                        ]
                      }
                    ];
                }
            localStorage.setItem("pb_menu", JSON.stringify(this.menu));
            this.$store.commit("setTags", "");
            this.$store.commit("setMenu", this.menu);
            userMsg().then(msg => {
              localStorage.setItem("pb_user_name", msg.name);
              this.$store.commit("setUserName", msg.name);
            })
            this.$router.push(this.menu[0].children[0].path);

            })
        } else {
          this.$tips(this, "失败", "error");
        }

      });
    },
  }
};
</script>
<style lang="less" scoped>
.login-wrap {
  width: 300px;
  padding: 20px;
  margin: 300px auto;
  background-color: #f2f2f2;
  .login-title {
    font-size: 30px;
    padding-bottom: 20px;
    text-align: center;
  }
}
</style>





// WEBPACK FOOTER //
// src/views/Login.vue